// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"eaab14b5","410":"f65131da","472":"09162ad2","548":"09162ad2","738":"09162ad2","889":"84d95a63"}[chunkId] + ".chunk.css";
};